import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import imageForfait from '../../../images/imageforfait.png'
import useFirebase from './../../../firebase/useFirebase';

const Forfait = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { readData, profil, count } = useFirebase()

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[count])

    if (montage) return <Spinner />
    
    return (
        <div className='container-fluid'>
            <HeaderReturn title='forfait' image={imageForfait} link='/homeServeur'/>
            {profil.map(p => (
                <div key={p.id}>
                    <div>{p.forfait}</div>
                </div>
            ))}
        </div>
    )
}

export default Forfait